import { Outlet } from '@tanstack/react-router';
import { useUserProposalQuery } from '@anytag/graphql';
import { useMatchPaths, useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { Header } from '@anytag/shared-molecules';
import { ButtonAddInfluencer, stickyInfluencersSearchHeader, UserProposalProvider } from '@anytag/shared-organisms';
import { cn } from '@anytag/shared-utils';
import { InfluencersTabs } from './influencers-tabs';

export const InfluencersRoot = () => {
  useUpdateDocumentTitle({ title: 'documentTitle.Influencer', appHeader: 'appHeader.Influencer' });
  const { data, loading } = useUserProposalQuery();
  const { matched } = useMatchPaths(['/influencers/proposal']);

  return (
    <div>
      <div
        className={cn(stickyInfluencersSearchHeader, {
          'h-8': matched
        })}
      >
        <Header className="bg-white">
          <ButtonAddInfluencer className="ml-auto" />
        </Header>
        <InfluencersTabs className="flex h-full flex-col"></InfluencersTabs>
      </div>
      <UserProposalProvider value={{ userProposal: data?.userProposal, loading }}>
        <Outlet />
      </UserProposalProvider>
    </div>
  );
};
